export function validateStreetAddress(streetAddress) {
  if (!streetAddress) return;

  const value = (streetAddress.value || "").trim();
  const hasValue = value.length > 0;
  const isValid = hasValue && isValidStreetAddress(value);

  streetAddress.classList.toggle("is-valid", hasValue && isValid);
  streetAddress.classList.toggle("is-invalid", hasValue && !isValid);
}

const STREET_ADDRESS_REGEX = /^\d+[A-Za-z]?(?:[\/-]\d+[A-Za-z]?)*\s+\S.*$/;

function isValidStreetAddress(streetAddressString) {
  return STREET_ADDRESS_REGEX.test(streetAddressString);
}